module.exports = __webpack_public_path__ + "nav-5a22de4b7a2551a76837.svg";